import SVTAPI from './svtapi';

class WebshopUsers extends SVTAPI {
  constructor() {
    super('/webshop_users');
  }

  /**
   * GET /webshop_users/:term
   * Searches for webshop users.
   *
   * @param {Object} params The parameters to use in the search
   * @param {string} params.term Search term that the users must match
   * @returns {Object} The server's response
   */
  search(params = {}) {
    return super.get({ url: '/' + params.term });
  }
}

export default new WebshopUsers();
